import { Component, Input, isDevMode, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormStateControl } from '@cbuild/shared';
@Component({
  selector: 'cs-create-note',
  standalone: false,
  templateUrl: './create-note.component.html'
})
export class CreateNoteComponent extends FormStateControl implements OnInit {
  @Input()
  public form: FormGroup;

  constructor(private fb: FormBuilder) {
    super();
  }

  public ngOnInit(): void {
    if (isDevMode() && !this.form) {
      throw new Error('Invalid Lead or parent from');
    }
    this.updateInfoFrom();
  }

  private updateInfoFrom(): void {
    const group = this.form.get('note');
    if (!group) {
      this.infoForm = this.initializeInfoForm();
      this.form.addControl('note', this.infoForm);
    } else {
      this.infoForm = this.form.get('note') as FormGroup;
    }
  }

  private initializeInfoForm(): FormGroup {
    return this.fb.group({
      note: ['']
    });
  }
}
